export default __webpack_public_path__ + "static/media/icon_listview_open_24_Regular.2dea9102.svg";